import { useQuery } from "@tanstack/react-query";
import { AXIOS_RESERVATION } from "../utils/axios-interceptors";
import { IUseGetDepartmentsData } from "../utils/types";

const useGetDepartmentsData = (): IUseGetDepartmentsData => {
  return useQuery({
    queryKey: ["department-data"],
    queryFn: async () => {
      const response = await AXIOS_RESERVATION.get(`/getAllDepartments`);

      return response?.data;
    },
  });
};

export default useGetDepartmentsData;
